import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { InputBase } from '@mui/material';
import { enqueueSnackbar } from 'actions';
import ModalDialog from '../../../../../../../components/ModalDialog/ModalDialog.js';
import { SetFormState, RemoveAttachment, ToggleRemoveFileIncidentTrackerDialog } from '../../../../../actions/IncidentTrackerActions';

const IncidentTrackerDeleteFileDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	const tableId = useSelector((state) => state.incidentTrackerDemoReducer.tableId);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.incidentTrackerDemoReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	const _onConfirmClick = () => {
		dispatch(RemoveAttachment(userId, tableId));
		dispatch(ToggleRemoveFileIncidentTrackerDialog(false));
		dispatch(enqueueSnackbar({ message: 'Attachment deleted', options: { variant: 'info' } }));
		setFormState({
			...formState,
			values: {
				...formState.values,
				hasAttachment: false
			}
		});
	};

	return (
		<ModalDialog
			maxWidth="xs"
			onClose={onClose}
			open={open}
			title="Delete attachment"
			confirmLabel="Ok"
			onConfirmClicked={_onConfirmClick}
		>
			<InputBase
				// className={classes.margin}
				defaultValue="Do you want to delete this attachment?"
				inputProps={{ 'aria-label': 'naked' }}
				fullWidth
			/>
		</ModalDialog>
	);
};

IncidentTrackerDeleteFileDialog.propTypes = {
	author: PropTypes.object.isRequired,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
};

export default IncidentTrackerDeleteFileDialog;
